import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

export const RxLpComFootnotes: FC = () => {
  return (
    <div className="tablet:flex tablet:justify-center">
      <div className="container flex-col px-4 pt-3 tablet:pb-14 tablet:pt-6">
        <p className="text-xs tracking-xs text-dark-primary-strong">
          <FormattedMessage id="rx.com.footer.note.7" />
        </p>
      </div>
    </div>
  )
}
